"use client"
import React from 'react'
import styles from './PodcastSection.module.scss'
import MicrophoneWithThreeLines from '@/SvgIcons/MicrophoneWithThreeLines';

const PodcastSection = ({Title,Content, YTLink,isMobile,enabled=false}) => {

  const extractVideoId = (url) => {
    if (url?.startsWith("https://youtu.be/")) {
      return url?.split("/")?.pop()?.split("?")[0];
    }
    if (url?.includes("youtube.com") && url?.includes("v=")) {
      return new URLSearchParams(new URL(url).search).get("v");
    }
    return url;
  };
  if(!enabled){
    return null;
  }

  const videoId = extractVideoId(YTLink);

  return (
    <section className={styles.root}>
        <div className={styles.container}>
        <div className={styles.podcast_block}>
        <div className={styles.main}>
        <div className={styles.videoWrapper}>
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
        </div>
        <div className={styles.content}>
            <div className={styles.heading}>
             
              <h2>
              {isMobile?<MicrophoneWithThreeLines height={30} width={35}/>:<MicrophoneWithThreeLines height={35} width={25}/>}<span>{Title}</span></h2>
            </div>
            <div className={styles.para} dangerouslySetInnerHTML={{
              __html: Content }}>
            </div>
        </div>
        </div>
        </div>
        </div>
    </section>
  );
};

export default PodcastSection
